export function FortHillLogo({ width = 220 }) {
  return (
    <img src="/logo.avif" alt="Fort Hill Associates" style={{ width, height: 'auto' }} />
  );
}

export function SidebarLogo() {
  return (
    <img src="/logo.avif" alt="Fort Hill Associates" style={{ width: '100%', height: 'auto', maxHeight: 50, objectFit: 'contain' }} />
  );
}
